export default "__VITE_ASSET__C3zXb_VC__"